import { createUseSafeLocationState } from '~/utils/SafeLocationState';

interface ISelectDatesLocationState {
  professionType: string;
  preselectedDate: string;
  professionals: Array<string | { id: string; name: string }>;
}

export const useSafeSelectDatesLocationState =
  createUseSafeLocationState<ISelectDatesLocationState>({
    professionType: '',
    preselectedDate: '',
    professionals: [],
  });
